<template>
  <div class="shop-intro-mutate" :class="{ 'shop-intro-mutate--empty': !this.description }">
    <ButtonComponent
      :label="labelComp"
      type="button"
      :icon="['fal', 'text']"
      @click="
        () => {
          show = true
          $emit('track', 'Intro')
        }
      "
    />

    <Modal :show="show" @close="close">
      <Card theme="border">
        <template #default>
          <MediaComponent
            v-if="'cover' in $options.propsData"
            v-model="data.cover"
            :label="$t('cover')"
            :upload-options="{ compression: { maxWidth: 1920 } }"
            accept="image/*"
            :enableDescription="false"
            :enableAlt="false"
            class="mb-2"
          />
          <InputComponent :label="label">
            <RichTextComponent v-model="data.description" />
          </InputComponent>
          <slot name="default" />
        </template>
        <template #footer>
          <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="close" />
          <ButtonComponent :label="$t('confirm')" :icon="['fal', 'angle-right']" theme="primary" @click="submit" />
        </template>
      </Card>
    </Modal>
  </div>
</template>

<script>
import { ModalComponent as Modal } from 'vue-elder-modal'
import Card from '@/components/Card'
import RichTextComponent from '@kvass/rich-text'
import { InputComponent } from 'vue-elder-input'
import { MediaComponent } from '@kvass/media'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { StripHTML } from '@/utils'

export default {
  props: {
    cover: Object,
    description: String,
    label: {
      type: String,
      default: 'Description',
    },
  },
  watch: {
    show: {
      handler(val) {
        this.data.description = val ? this.description : null
        this.data.cover = val ? this.cover : null
      },
      immediate: true,
    },
  },
  data() {
    return {
      show: false,
      data: {
        cover: null,
        description: null,
      },
    }
  },
  computed: {
    labelComp() {
      return !this.description
        ? `${this.$t('setValue', { value: this.label.toLowerCase() })}`
        : StripHTML(this.description).substring(0, 15) + '...'
    },
  },
  methods: {
    submit() {
      this.$emit('update:description', this.data.description)
      this.$emit('update:cover', this.data.cover)
      this.close()
    },
    close() {
      this.show = false
    },
  },
  components: {
    Modal,
    Card,
    RichTextComponent,
    InputComponent,
    Alert,
    MediaComponent,
  },
}
</script>

<style lang="scss">
.shop-intro-mutate {
  display: flex;

  .elder-modal {
    font-size: 1rem;
  }

  .kvass-media-droparea {
    min-height: 400px;
  }

  &--empty > .elder-button {
    .elder-button__label {
      opacity: 0.7;
    }
  }

  .card {
    width: 100%;
    max-width: 900px;

    &__footer {
      display: flex;
      justify-content: flex-end;
      &-content {
        display: flex;
      }
    }
  }
}
</style>
